The metrics are calculated based on the definition stated in Performance Summary.
